<template>
  <div class="serveUseAppDetail">
    <div class="serveUseAppDetail-top" v-if="appForm && appForm.name">
      <p class="font16 fonttwodark mb-24 fontbig">基础信息</p>
      <p class="font20 fontdark">
        <span class="mr-16">{{ appForm.name }}</span>
      </p>
      <tooltip-card class="fontthreedark overhidden mt-4 mb-24" :text="appForm.appDescribe"></tooltip-card>
      <!-- <p class="fontthreedark overhidden mt-4 mb-24">
        {{ appForm.appDescribe }}
      </p> -->
      <p>
        <span class="mr-16">AppID：{{ appForm.id }}</span>
        <i
          class="icon tsit icon_fuzhi fontblue copyid"
          data-clipboard-action="copy"
          :data-clipboard-text="appForm.id"
          @click="copyLink('.copyid')"
        ></i>
      </p>
      <p>
        <span class="mr-16"
          >Secret Key：{{ isShow ? appForm.appSecret : "********" }}</span
        >
        <i
          class="icon tsit icon_fuzhi fontblue copysecret"
          data-clipboard-action="copy"
          :data-clipboard-text="appForm.appSecret"
          @click="copyLink('.copysecret')"
        ></i>
        <span class="ml-8 mr-8">|</span>
        <span class="fontblue fontcursor" @click="showPwd">
          {{ isShow ? "隐藏密钥" : "显示密钥" }}
        </span>
      </p>
      <p class="mt-4">
        <span class="mr-16"
          >事件推送地址：{{ appForm.eventAddr || "暂无数据" }}</span
        >
      </p>
    </div>
    <div class="serveUseAppDetail-btm mt-24">
      <div class="mb-24">
        <p class="font16 fontbig">服务列表</p>
        <div class="divider_line mt-16"></div>
        <div v-if="serveList && serveList.length">
          <Table :columns="dataCol" :data="serveList">
            <template slot-scope="{ row }" slot="status">
              <span :class="`${statusList[row.status].color} mr-4`"></span>
              <span>{{ statusList[row.status].name }}</span>
            </template>
          </Table>
        </div>
        <div v-else class="flexcolcenter">
          <img src="@/assets/img/serveuse/serveuse_null_default.png" alt />
          <p class="fontthreedark">暂未绑定服务</p>
        </div>
      </div>
      <div>
        <p class="font16 fontbig">视频资源</p>
        <div class="divider_line mt-16 mb-24"></div>
        <div class="flexend mb-24">
          <div class="flexfs">
            <Input
              placeholder="请输入要搜索的视频资源名称或国标ID"
              v-model="searchKey"
              @on-enter="searchKay"
              @on-clear="searchKeyClear"
              style="width: 300px"
              clearable
            />
            <Button
              type="primary"
              shape="circle"
              class="ml-16 w100px"
              @click="searchKay"
            >
              搜索
            </Button>
          </div>
        </div>
        <div v-if="hasResource">
          <treeCom
            @isData="isData"
            :userId="appForm.userId"
            v-show="isTree"
            ref="treeCustom"
            appFlag="0"
            :groupId.sync="groupId"
          ></treeCom>
          <!-- 搜索的结果 -->
          <SelectResourceSearch
            ref="selectResourceSearch"
            :id="appId"
            v-show="!isTree"
            :groupId.sync="groupId"
          ></SelectResourceSearch>
        </div>
        <div v-show="!hasResource" class="flexcolcenter">
          <img src="@/assets/img/serveuse/serveuse_null_default.png" alt />
          <p class="fontthreedark">暂无视频资源</p>
        </div>
      </div>
      <Button shape="circle" type="primary" class="mt-16 mr-40 w104px" @click="link('/serveUse/serveUseAppList')">返回</Button>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import treeCom from "@/components/treeCustom/ElTree.vue";
import tooltipCard from "@/components/card/tooltip-card.vue";
import SelectResourceSearch from "./components/app-info-resource-search";
import {
  getServePubilshBase,
  getServePubilshServeList,
} from "@/api/serviceUse";
import { getMyAppVideoTreeFirst } from "@/api/app";
const dataCol = [
  {
    title: "服务名称",
    key: "name",
    tooltip: true,
    minWidth: 150,
  },
  {
    title: "服务场景",
    key: "sceneTypeName",
    tooltip: true,
    minWidth: 150,
  },
  {
    title: "所属企业",
    key: "companyName",
    tooltip: true,
    minWidth: 150,
  },
  {
    title: "服务类型",
    key: "serviceTypeName",
    tooltip: true,
    minWidth: 150,
  },
  {
    title: "介绍",
    key: "introduce",
    tooltip: true,
    minWidth: 150,
  },
  {
    title: "视频资源数量",
    key: "sourceNum",
    tooltip: true,
    minWidth: 150,
  },
  {
    title: "状态",
    slot: "status",
    minWidth: 150,
  },
];
export default {
  name: "",
  components: {
    treeCom,
    SelectResourceSearch,
    tooltipCard
  },
  data() {
    return {
      appFlag: "1",
      isShow: false,
      baseMsg: {},
      dataCol: dataCol,
      statusList: [
        {
          id: 0,
          name: "已启用",
          color: "circle_dot circle_success",
        },
        {
          id: 1,
          name: "已禁用",
          color: "circle_dot circle_off",
        },
        {
          id: 2,
          name: "已下架",
          color: "circle_dot circle_warn",
        },
        {
          id: 3,
          name: "待下架",
          color: "circle_dot circle_on",
        },
      ],
      appForm: {},
      serveList: [],
      hasResource: false,
      appId: "",
      isTree: true, //是否展示树
      searchKey: "", //搜索名称
      groupId:""
    };
  },
  created() {
    this.appId = this.$route.query.id;
    console.log("appId", this.appId);
  },
  mounted() {
    this.baseMessage(); //基础信息
    this.getServePubilshServeList(); //服务列表
  },
  methods: {
    link(path) {
      this.$router.push({
        path: path,
        query: {
          id: localStorage.getItem("adminAppId"),
        },
      });
    },
    searchKeyClear() {
      this.isTree = true;
      this.searchKey = "";
    },
    searchKay() {
      if (this.searchKey) {
        this.isTree = false;
        this.$nextTick(() => {
          this.$refs.selectResourceSearch.searchKay(this.searchKey);
        });
      } else {
        this.isTree = true;
      }
    },
    // 基础信息
    baseMessage() {
      getServePubilshBase(this.appId)
        .then((res) => {
          console.log("服务使用者发布服务详情==基础信息", res);
          this.appForm = res.data.data;
          this.getAppVideoTree();
        })
        .catch((err) => {
          console.log("接口请求失败", err);
        });
    },
    //服务列表
    getServePubilshServeList() {
      getServePubilshServeList(this.appId)
        .then((res) => {
          console.log("服务使用者发布服务详情==服务列表", res);
          this.serveList = res.data.data;
        })
        .catch((err) => {
          console.log("接口请求失败", err);
        });
    },
    getAppVideoTree() {
      getMyAppVideoTreeFirst(this.appId, { userId: this.appForm.userId }).then(
        (res) => {
          let json = res.data.data;
          if (json) {
            this.hasResource = true;
          }
          console.log("this.hasResource", this.hasResource);
        }
      );
    },
    isData(val) {
      // this.hasResource = val;
      // console.log("this.hasResource", this.hasResource);
    },
    showPwd() {
      console.log(this.isShow, "显示隐藏秘钥");
      this.isShow = !this.isShow;
    },
    copyLink(type) {
      let self = this;
      let clipboard = new Clipboard(type);
      clipboard.on("success", function () {
        self.$Message.success("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", function () {
        self.$Message.success("复制失败");
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="scss">
.serveUseAppDetail {
  width: 100%;
  height: 100%;
  overflow: auto;
  &-top {
    width: 100%;
    box-shadow: 0px 2px 10px 0px rgba(186, 187, 189, 0.05);
    border-radius: 8px;
    background: #fff;
    padding: 24px 32px;
  }
  &-btm {
    min-height: calc(100% - 244px);
    box-shadow: 0px 2px 10px 0px rgba(186, 187, 189, 0.05);
    border-radius: 8px;
    background: #fff;
    padding: 24px 32px;
    &-servelist_top {
      height: 55px;
      background: #dcdfe6;
      border-radius: 4px 4px 0px 0px;
      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
    }
  }
}
</style>